import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/afruity.css";
import reportWebVitals from "./reportWebVitals";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
